
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.795 2.833H4.667a1.834 1.834 0 00-1.834 1.834v3.166c0 1.013.821 1.834 1.834 1.834h10.666a1.834 1.834 0 001.834-1.834v-2.06a2.084 2.084 0 10-2.372-2.94zm2.955.917a1.083 1.083 0 11-2.167 0 1.083 1.083 0 012.167 0zm-1.583 2.023a2.084 2.084 0 01-1.582-1.94H4.667a.833.833 0 00-.834.834v3.166c0 .46.373.834.834.834h10.666c.46 0 .834-.373.834-.834v-2.06zM2.833 12.167c0-1.013.821-1.834 1.834-1.834h10.666c1.013 0 1.834.821 1.834 1.834v3.166a1.834 1.834 0 01-1.834 1.834H4.667a1.833 1.833 0 01-1.834-1.834v-3.166zm1.834-.834a.833.833 0 00-.834.834v3.166c0 .46.373.834.834.834h10.666c.46 0 .834-.373.834-.834v-3.166a.833.833 0 00-.834-.834H4.667z","fill":"#4F5861"}})])
          )
        }
      }
    